import { Form } from 'antd';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { Icon } from '../../components/icon/icon';
import './PaymentPage.scss';
import { Flex } from 'antd';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import MethodPaymentRadio from '../../components/payment/MethodPaymentRadio/MethodPaymentRadio';
import { useCallback, useEffect, useState } from 'react';
import { Divider } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import ButtonSecondaryLarge from '../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import { useDispatch, useSelector } from 'react-redux';
import Tag from '../../components/common/Tag/Tag';
import { fetchListAddress } from '../../store/actions/address.action';
import { cn } from '../../utils/string/cn.utils';
import CardItem from '../../components/card/CardItem/CardItem';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import {
  createOrder,
  createPayment,
  verifyPayment,
} from '../../store/actions/room.action';
import { Spin } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { openMessageError } from '../../components/common/Message/openMessageError';
import ROUTER from '../../routers/Routers';
import ButtonSecondaryMedium from '../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import formatDateTime from '../../utils/dayjs/formatDateTime.util';
import useModalAddress from '../../components/common/ModalAddress/ModalAddress';
import { getValueFromString } from '../../utils/data/getValue.utils';
import CheckboxComponent from '../../components/common/CheckboxComponent/CheckboxComponent';
import ButtonLink from '../../components/common/ButtonLink/ButtonLink';
import { parseJson } from '../../utils/string/parseJson';
import { roundTo } from '../../utils/geometry/epsilon';
import ButtonIconOutlineLarge from '../../components/common/ButtonIconOutline/ButtonIconOutlineLarge';
import { convertForeignCurrency } from '../../utils/currency/currency.utils';

const PaymentPage = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [form] = Form.useForm();

  // const [listAdd, setListAdd] = useState([]);
  // const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [methodPay, setMethodPay] = useState('0');
  const [layoutPayment, setLayoutPayment] = useState(null);
  // const [amountPay, setAmountPay] = useState({
  //   total: 0,
  //   total1: 0,
  //   total2: 0,
  //   total3: 0,
  // });

  const { listAddress, provinces, wards } = useSelector(state => state.address);
  const { order } = useSelector(state => state.room);
  const { data } = location.state || {};

  const [searchParams, setSearchParams] = useSearchParams();
  const tempResponseCode = searchParams.get('vpc_TxnResponseCode');

  const watchCF1 = Form.useWatch('confirm1', form);
  const watchCF2 = Form.useWatch('confirm2', form);
  const watchCF3 = Form.useWatch('confirm3', form);
  const watchCF4 = Form.useWatch('confirm4', form);
  const watchCF5 = Form.useWatch('confirm5', form);
  const watchCF6 = Form.useWatch('confirm6', form);

  const {
    handleData,
    openModalListAddress,
    deliveryAddress,
    setDeliveryAddress,
    form: formAddress,
    listAdd,
    setListAdd,
    // setListAdd,
  } = useModalAddress({
    handleUpdateAddress: addressId => {
      // dispatch(
      //   updateOrder({ billAddress: addressId, id: order.detail.id })
      // ).then(action => {
      //   if (action.payload?.data) {
      //     openMessageSuccess({ content: t('Successfully') });
      //   }
      // });
    },
  });

  const renderCardItems = () => {
    if (data?.items === undefined) return;
    const itemList = parseJson(data?.items || '[]');
    return itemList?.map((item, index) => {
      return (
        <CardItem
          icon={item.thumbnail}
          title={getValueFromString(item.item_name)}
          content={
            <>
              <div className="flex flex-col items-start gap-[4px] self-stretch">
                {item.total_wood_price ? (
                  <div className="flex justify-between items-center self-stretch grow">
                    <div className="flex items-center gap-[8px]">
                      <span className="text-body-small">
                        {t('Wood products')}
                      </span>
                      <span className="w-[12px] h-[12px] flex text-primary-primary">
                        <Icon.ICInfoFill />
                      </span>
                    </div>
                    <span className="text-body-medium font-semibold">
                      {convertForeignCurrency(item.total_wood_price ?? 0)}
                    </span>
                  </div>
                ) : null}
                {item.total_countertop_price || item.total_backsplash_price ? (
                  <div className="flex justify-between items-center self-stretch grow">
                    <div className="flex items-center gap-[8px]">
                      <span className="text-body-small">
                        {t('Stone & Glass')}
                      </span>
                      <span className="w-[12px] h-[12px] flex text-primary-primary">
                        <Icon.ICInfoFill />
                      </span>
                    </div>
                    <span className="text-body-medium font-semibold">
                      {convertForeignCurrency(
                        (item.total_countertop_price ?? 0) +
                          (item.total_backsplash_price ?? 0)
                      )}
                    </span>
                  </div>
                ) : null}
                {item.total_accessory_price ? (
                  <div className="flex justify-between items-center self-stretch grow">
                    <div className="flex items-center gap-[8px]">
                      <span className="text-body-small">
                        {t('Accessories')}
                      </span>
                      <span className="w-[12px] h-[12px] flex text-primary-primary">
                        <Icon.ICInfoFill />
                      </span>
                    </div>
                    <span className="text-body-medium font-semibold">
                      {convertForeignCurrency(item.total_accessory_price ?? 0)}
                    </span>
                  </div>
                ) : null}
              </div>
              <Divider type="horizontal" className="!p-0 m-0" />
              <div className="flex lg:flex-row flex-col justify-end lg:items-center items-end self-stretch grow gap-[12px]">
                {item.discount_value && item.discount_type ? (
                  <Tag
                    label={
                      <div className="flex items-center justify-center gap-[4px]">
                        <span className="flex w-[16px] h-[16px]">
                          <Icon.ICPercentDiscount />
                        </span>
                        <span className="text-label-medium">
                          {t('{{x}}% Off', {
                            x:
                              item.discount_type === 'PERCENT_DISCOUNT'
                                ? `${item.discount_value || 0}`
                                : `${convertForeignCurrency(item.discount_value)}`,
                          })}
                        </span>
                      </div>
                    }
                    className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                  />
                ) : null}
                <div className="flex items-end flex-row gap-[12px]">
                  <span className="text-body-small line-through text-black-medium">
                    {(() => {
                      if (
                        Number(item.price_after) !== Number(item.price_original)
                      ) {
                        return convertForeignCurrency(
                          Number(item.price_original)
                        );
                      }
                    })()}
                  </span>
                  <span
                    className={cn(
                      'truncate text-body-large font-semibold self-stretch',
                      Number(item.price_after) !== Number(item.price_original)
                        ? 'text-Accents-Red'
                        : 'text-black'
                    )}
                  >
                    {convertForeignCurrency(
                      (() => {
                        if (Number(item.price_after)) {
                          return Number(item.price_after);
                        } else {
                          return (
                            (item.total_wood_price ?? 0) +
                            (item.total_accessory_price ?? 0) +
                            (item.total_countertop_price ?? 0) +
                            (item.total_backsplash_price ?? 0)
                          );
                        }
                      })()
                    )}
                  </span>
                </div>
              </div>
            </>
          }
          quantity={0}
          classNames={{
            root: 'p-[12px] rounded-[12px] bg-fills-white shadow-custom',
            icon: 'w-[60px] h-[60px]',
            content: 'flex-col gap-[8px] self-stretch flex-nowrap',
            iconContainer: 'items-start justify-start',
          }}
        />
      );
    });
  };

  const renderTypePayment = () => {
    if (Number(data?.type) === 1) {
      return (
        <div className="flex p-[16px] flex-col items-start gap-[12px] self-stretch rounded-[16px] bg-[#F7F7F7] stroke-primary-primary">
          <span className="text-label-large font-semibold text-black/60">
            {t('Payment type')}
          </span>
          <div className="flex lg:flex-row flex-col items-start gap-[8px] self-stretch justify-between">
            <span className="text-body-large font-semibold">
              {t('Pay for the entire order')}
            </span>
            <span className="text-body-large font-semibold text-primary-primary">
              {convertForeignCurrency(data?.amount)}
            </span>
          </div>
        </div>
      );
    } else if (Number(data?.type) === 2) {
      return (
        <>
          {Array.from({ length: (data?.paid_step ?? 0) + 1 }).map(
            (_, index) => {
              switch (index) {
                case 0:
                  return (
                    <div
                      className={cn(
                        'flex p-[16px] flex-col items-start gap-[12px] self-stretch rounded-[16px] bg-[#F7F7F7]',

                        'border-primary-primary border-[2px] border-solid'
                      )}
                    >
                      <span className="text-label-large font-semibold text-black/60">
                        {t('Payment type')}
                      </span>
                      <div className="flex lg:flex-row flex-col items-start gap-[8px] self-stretch">
                        <span className="text-body-large font-semibold grow">
                          {data?.paid_step === 1
                            ? t('Paid first time')
                            : t('Pay first time')}
                        </span>
                        <span
                          className={cn(
                            'text-body-large font-semibold',
                            data?.paid_step === 0 ? 'text-primary-primary' : ''
                          )}
                        >
                          {convertForeignCurrency(
                            data?.payment_installments?.[0]?.amount
                          )}
                        </span>
                      </div>
                    </div>
                  );
                case 1:
                  return (
                    <div
                      className={cn(
                        'flex p-[16px] flex-col items-start gap-[12px] self-stretch rounded-[16px] bg-[#F7F7F7]',
                        'border-primary-primary border-[2px] border-solid'
                      )}
                    >
                      <span className="text-label-large font-semibold text-black/60">
                        {t('Payment type')}
                      </span>
                      <div className="flex lg:flex-row flex-col items-start gap-[8px] self-stretch">
                        <span className="text-body-large font-semibold grow">
                          {data?.paid_step === 2
                            ? t('Paid second time')
                            : t('Pay second time')}
                        </span>
                        <span
                          className={cn(
                            'text-body-large font-semibold',
                            data?.paid_step == 1 ? 'text-primary-primary' : ''
                          )}
                        >
                          {convertForeignCurrency(
                            data?.payment_installments?.[1]?.amount
                          )}
                        </span>
                      </div>
                    </div>
                  );
                case 2:
                  return (
                    <div
                      className={cn(
                        'flex p-[16px] flex-col items-start gap-[12px] self-stretch rounded-[16px] bg-[#F7F7F7]',

                        'border-primary-primary border-[2px] border-solid'
                      )}
                    >
                      <span className="text-label-large font-semibold text-black/60">
                        {t('Payment type')}
                      </span>
                      <div className="flex lg:flex-row flex-col items-start gap-[8px] self-stretch">
                        <span className="text-body-large font-semibold grow">
                          {data?.paid_step === 3
                            ? t('Paid last time')
                            : t('Pay last time')}
                        </span>
                        <span
                          className={cn(
                            'text-body-large font-semibold',
                            data?.paid_step === 2 ? 'text-primary-primary' : ''
                          )}
                        >
                          {convertForeignCurrency(
                            data?.payment_installments?.[2]?.amount
                          )}
                        </span>
                      </div>
                    </div>
                  );
              }
            }
          )}
        </>
      );
      // if (Number(data?.paid_step) === 0) {
      //   return t('First payment');
      // } else if (Number(data?.paid_step) === 1) {
      //   return t('Second payment');
      // } else if (Number(data?.paid_step) === 2) {
      //   return t('Third payment');
      // }
    }
  };

  // Thêm function mở payment popup
  const openPaymentPopup = useCallback(paymentUrl => {
    const width = 800;
    const height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    let popup = window.open(
      paymentUrl,
      'PaymentWindow'
      // `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`
    );

    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      openMessageError({ content: t('Popup blocked! Please allow popups.') });
      popup = window.open(paymentUrl);
      return null;
    }

    return popup;
  }, []);

  const createLinkPayment = data => {
    let pay = null;
    if (Number(data.type) === 1) pay = data.amount - data.amount_paid;
    else {
      pay = data.payment_installments?.[data.paid_step]?.amount;
    }
    dispatch(
      createPayment({
        billAddress: deliveryAddress?.id,
        amountPaid: pay?.toString(),
        paymentMethod: methodPay,
        paymentTerm: '0',
        orderCode: data.code,
        returnUrl: window.location.href,
        customerPhone: deliveryAddress?.phone,
      })
    ).then(action => {
      if (action.payload?.data) {
        openPaymentPopup(action.payload.data);
      } else {
        popup.close();
        openMessageError({
          content: t('Failed to initiate payment. Please try again.'),
        });
      }
    });
  };

  useEffect(() => {
    const handleMessage = event => {
      // Kiểm tra origin để bảo mật
      if (event.origin !== window.location.origin) return;
      if (event.data.type === 'PAYMENT_RESULT') {
        const queryString = event.data.data;
        const params = new URLSearchParams(queryString);
        const vpc_TxnResponseCode = params.get('vpc_TxnResponseCode');

        // window.history.replaceState({}, '', ROUTER.PAYMENT);
        navigate(ROUTER.PAYMENT, { replace: true, state: { data: data } });

        if (Number(vpc_TxnResponseCode) === 0)
          dispatch(verifyPayment({ params: queryString })).then(action => {
            if (action.payload?.data) {
              const status = action.payload.data.status;
              if (status === 'success') {
                openMessageSuccess({ content: t('Payment successful') });
              } else if (status === 'failed') {
                openMessageError({ content: t('Payment failed') });
              }
              setLayoutPayment(status);
            }
          });
        else {
          setLayoutPayment('failed');
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch, navigate, data]);

  useEffect(() => {
    if (tempResponseCode) {
      // Gửi message về parent window
      if (window.opener && !window.opener.closed) {
        // navigate('/payment', { replace: true });
        window.opener.postMessage(
          {
            type: 'PAYMENT_RESULT',
            data: window.location.search,
          },
          window.location.origin // Chỉ gửi về cùng origin
        );

        setTimeout(() => window.close(), 100); // Đóng popup sau khi gửi
      }
    }
  }, [tempResponseCode]);

  // useEffect(() => {
  //   if (data) {
  //     const total =
  //       (data.amount ?? 0) + (data.shipping_fee ?? 0) - (data.discount ?? 0);

  //     setAmountPay({
  //       total: total < 0 ? 0 : total,
  //       total1: total * 0.5,
  //       total2: total * 0.3,
  //       total3: total * 0.2,
  //     });
  //   }
  // }, [data]);

  useEffect(() => {
    if (listAdd.length) {
      console.log(data, data.bill_address);
      if (data?.bill_address) {
        const address = listAdd.find(
          item => item.id?.trim() === data.bill_address.trim()
        );
        setDeliveryAddress(address);
      } else {
        setDeliveryAddress(listAdd.find(item => item.is_default));
      }
    }
  }, [data, listAdd]);

  useEffect(() => {
    if (listAddress?.data?.length > 0) {
      setListAdd([...(listAddress.data ?? [])]);
      handleData();
    }
  }, [listAddress]);

  useEffect(() => {
    if (listAddress.isNeedReloadData) dispatch(fetchListAddress());
  }, [listAddress]);

  useEffect(() => {
    form.setFieldValue('deliveryAddress', deliveryAddress?.id);
  }, [deliveryAddress]);

  if (layoutPayment === 'success') {
    return <SuccessfulPayment {...{ order }} />;
  } else if (layoutPayment === 'failed') {
    return <FailurePayment />;
  } else if (!layoutPayment && !data && tempResponseCode) {
    return (
      <section className="h-full w-full flex items-center justify-center">
        <Spin spinning />
      </section>
    );
  } else if (!layoutPayment && !data && !tempResponseCode) {
    return <WarningPayment />;
  } else {
    return (
      <>
        <Form
          layout="vertical"
          form={form}
          className="paymentpage flex w-full flex-col items-start"
        >
          <div className="lg:flex md:px-20 px-16 py-12 grow grid grid-cols-5  lg:py-[24px] lg:px-80 flex-col lg:justify-start lg:items-start justify-center items-center gap-16 self-stretch lg:bg-transparent bg-fills-white">
            <ButtonIconOutlineLarge
              icon={<Icon.ICArrowBack />}
              onClick={() => navigate(-1)}
              className="lg:hidden col-span-1"
            />

            <span className="!font-bold text-title-large lg:text-headline-small flex flex-col items-center justify-center gap-[24px] grow col-span-3">
              {t('Payment')}
            </span>
          </div>
          <div className="flex lg:flex-row flex-col-reverse self-stretch md:px-20 px-16 py-16 lg:px-80 gap-16 lg:gap-[40px]">
            <div className="flex flex-col items-start gap-16 justify-start self-stretch grow">
              <section className="flex lg:p-[40px] lg:pb-[32px] p-[16px] flex-col items-start gap-[24px] self-stretch rounded-[16px] bg-fills-white shadow-custom">
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-title-large !font-bold">
                    {t('Payment information')}
                  </span>
                </div>
                <div className="flex flex-col items-start gap-16 self-stretch">
                  {renderTypePayment()}
                </div>
              </section>
              <section className="flex lg:p-[40px] lg:pb-[32px] p-[16px] flex-col items-start lg:gap-[24px] gap-16 self-stretch rounded-[16px] bg-fills-white shadow-custom">
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-title-large !font-bold">
                    {t('Shipping information')}
                  </span>
                </div>

                {deliveryAddress ? (
                  <div className="card-address flex p-[16px]  items-start gap-[24px] self-stretch rounded-[16px] bg-fills-white border-[1px] border-[#E0E0E0]">
                    <div className="flex flex-col items-start self-stretch gap-[12px] grow">
                      <div className="flex justify-between items-center self-stretch">
                        <div className="flex items-center gap-16">
                          <Tag
                            className="bg-[#E3EFFB] text-[#145B90]"
                            label={
                              <span className="text-label-medium">
                                {deliveryAddress.address_name}
                              </span>
                            }
                          />
                          {deliveryAddress.is_default && (
                            <span className="text-label-medium text-primary-primary font-semibold">
                              {t('Default address')}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center gap-[8px] grow self-stretch">
                        <span className="text-label-large font-semibold">
                          {deliveryAddress.contact_name}
                        </span>
                        <Divider type="vertical" className="m-0 !p-0" />
                        <span className="text-label-large font-semibold">
                          {deliveryAddress.phone}
                        </span>
                      </div>
                      <span className="text-body-medium">{`${deliveryAddress.addressFull ?? '...'}`}</span>
                    </div>

                    <ButtonIconOutlineMedium
                      type="button"
                      icon={<Icon.ICEdit />}
                      onClick={() => {
                        openModalListAddress(deliveryAddress.id);
                      }}
                    />
                  </div>
                ) : listAddress.isLoading ? (
                  <Spin size="small" spinning />
                ) : (
                  <ButtonSecondaryMedium
                    type="button"
                    title={t('Add delivery address')}
                    onClick={() => {
                      openModalListAddress(deliveryAddress?.id);
                    }}
                  />
                )}
              </section>
              <section className="flex lg:p-[40px] lg:pb-[32px] p-[16px] flex-col items-start lg:gap-[24px] gap-16 self-stretch rounded-[16px] bg-fills-white shadow-custom">
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-title-large !font-bold">
                    {t('Payment method')}
                  </span>
                </div>
                <div className="flex flex-col items-start gap-16 self-stretch">
                  <MethodPaymentRadio
                    className="self-stretch gap-y-[16px]"
                    onChange={e => setMethodPay(e.target.value)}
                    value={methodPay}
                    options={[
                      {
                        value: '2',
                        label: (
                          <div className="flex items-start gap-[12px] self-stretch rounded-[4px] bg-fills-white m-0">
                            <span className="lg:w-[32px] lg:h-[32px] w-[24px] h-[24px] flex">
                              <Icon.ICQr />
                            </span>
                            <div className="flex gap-2 flex-col justify-center items-start grow">
                              <span className="text-title-small">
                                {t('Pay via QR code')}
                              </span>
                              <span className="text-body-medium">
                                {t(
                                  'Scan the code with banking apps and e-wallets'
                                )}
                              </span>
                            </div>
                          </div>
                        ),
                      },
                      {
                        value: '0',
                        label: (
                          <div className="flex items-start gap-[12px] self-stretch rounded-[4px] bg-fills-white m-0">
                            <span className="lg:w-[32px] lg:h-[32px] w-[24px] h-[24px] flex">
                              <Icon.ICPayment />
                            </span>
                            <div className="flex gap-2 flex-col justify-center items-start grow">
                              <span className="text-title-small">
                                {t('Domestic ATM card')}
                              </span>
                              <span className="text-body-small">
                                {t('Pay with NAPAS payment card')}
                              </span>
                            </div>
                          </div>
                        ),
                      },
                      {
                        value: '1',
                        label: (
                          <div className="gap-[12px] flex items-start self-stretch rounded-[4px] bg-fills-white">
                            <span className="lg:w-[32px] lg:h-[32px] w-[24px] h-[24px] flex">
                              <Icon.ICCreditCard />
                            </span>
                            <div className="flex gap-2 flex-col justify-center items-start grow">
                              <span className="text-title-small">
                                {t('Credit/Debit card')}
                              </span>
                              <span className="text-body-small">
                                {t(
                                  'Pay with Visa, MasterCard, Amex, JCB cards'
                                )}
                              </span>
                            </div>
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
                <div className="flex items-center gap-[8px] self-stretch p-[16px] lg:!p-0">
                  <span className="flex w-[34px] h-[24px]">
                    <Icon.ICVisa />
                  </span>
                  <span className="flex w-[34px] h-[24px]">
                    <Icon.ICMasterCard />
                  </span>
                  <span className="flex w-[34px] h-[24px]">
                    <Icon.ICJCB />
                  </span>
                  <span className="flex w-[34px] h-[24px]">
                    <Icon.ICAmex />
                  </span>
                  <span className="flex w-[34px] h-[24px]">
                    <Icon.ICZalo />
                  </span>
                </div>
              </section>
              <div className="flex flex-col items-start gap-[8px] self-stretch">
                <Form.Item name={'confirm1'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <span className="text-body-medium text-black/80">
                      {t(
                        'I have reviewed and confirmed the design, dimensions, configuration, and materials of the product.'
                      )}
                    </span>
                  </CheckboxComponent>
                </Form.Item>
                <Form.Item name={'confirm2'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <span className="text-body-medium text-black/80">
                      {t(
                        'I understand that payment means confirming the design and allowing Fitta to proceed with production.'
                      )}
                    </span>
                  </CheckboxComponent>
                </Form.Item>
                <Form.Item name={'confirm3'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <span className="text-body-medium text-black/80">
                      {t(
                        'I understand that custom-made products are not eligible for returns or exchanges once production has been confirmed.'
                      )}
                    </span>
                  </CheckboxComponent>
                </Form.Item>
                <Form.Item name={'confirm4'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <span className="text-body-medium text-black/80">
                      {t(
                        'I understand that the colors and materials displayed on the website may slightly differ from the actual product.'
                      )}
                    </span>
                  </CheckboxComponent>
                </Form.Item>
                <Form.Item name={'confirm5'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <span className="text-body-medium text-black/80">
                      {t(
                        'I understand that minor dimensional tolerances within technical limits are normal in furniture manufacturing.'
                      )}
                    </span>
                  </CheckboxComponent>
                </Form.Item>
                <Form.Item name={'confirm6'} valuePropName="checked">
                  <CheckboxComponent
                    className={
                      '[&_.ant-checkbox]:self-start [&_.ant-checkbox]:mt-[4px]'
                    }
                  >
                    <div className="flex flex-col items-start justify-start gap-[8px]">
                      <span className="text-body-medium">
                        {t('I have read and agree to:')}
                      </span>
                      <ul className="flex flex-col gap-[8px]">
                        <li>
                          <ButtonLink
                            title={t('Sales policy')}
                            style={{ color: '#258FD2' }}
                            icon={<Icon.ICOpenNewTab />}
                            onClick={() => {
                              navigate(
                                ROUTER.CENTER_SUPPORT + ROUTER.SALES_POLICY
                              );
                              // window.location.href =
                              //   ROUTER.CENTER_SUPPORT + ROUTER.SALES_POLICY;
                            }}
                          />
                        </li>
                        <li>
                          <ButtonLink
                            title={t('Warranty policy')}
                            style={{ color: '#258FD2' }}
                            icon={<Icon.ICOpenNewTab />}
                            onClick={() => {
                              navigate(
                                ROUTER.CENTER_SUPPORT + ROUTER.WARRANTY_POLICY
                              );
                              // window.location.href =
                              //   ROUTER.CENTER_SUPPORT +
                              //   ROUTER.WARRANTY_POLICY;
                            }}
                          />
                        </li>
                        <li>
                          <ButtonLink
                            title={t('Web-App Terms of Use')}
                            style={{ color: '#258FD2' }}
                            icon={<Icon.ICOpenNewTab />}
                            onClick={() => {
                              navigate(
                                ROUTER.CENTER_SUPPORT +
                                  ROUTER.WEB_APP_TERMS_OF_USE
                              );
                              // window.location.href =
                              //   ROUTER.CENTER_SUPPORT +
                              //   ROUTER.WEB_APP_TERMS_OF_USE;
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </CheckboxComponent>
                </Form.Item>
              </div>
              <div className="flex flex-col items-start self-stretch gap-16">
                <ButtonPrimaryLarge
                  type={'button'}
                  title={
                    t('Payment') +
                    ' ' +
                    convertForeignCurrency(
                      Number(data.type) === 1
                        ? data?.amount
                        : data?.payment_installments?.[data?.paid_step]?.amount
                    )
                  }
                  className="self-stretch"
                  disabled={
                    !deliveryAddress?.id ||
                    !deliveryAddress?.phone ||
                    methodPay === undefined ||
                    order.isLoading ||
                    !watchCF1 ||
                    !watchCF2 ||
                    !watchCF3 ||
                    !watchCF4 ||
                    !watchCF5 ||
                    !watchCF6
                  }
                  loading={order.isLoading}
                  onClick={() => {
                    if (!data.code) {
                      dispatch(
                        createOrder({
                          couponCodes: data.applied_coupons,
                          items: parseJson(data.items),
                          amount: data.amount,
                          discount: roundTo(data.discount, 0),
                          type: data.type,
                          bill_address: deliveryAddress?.id,
                          estimated_delivery_date: data.estimated_delivery_date,
                          order_type: data.order_type,
                        })
                      ).then(action => {
                        if (action.payload?.data) {
                          const data = action.payload.data;
                          navigate(ROUTER.PAYMENT, {
                            state: {
                              data: action.payload?.data,
                            },
                          });
                          createLinkPayment(data);
                        }
                      });
                    } else {
                      createLinkPayment(data);
                    }
                  }}
                />
              </div>
            </div>
            <section className="ticket-container flex items-start bg-fills-white flex-col rounded-[16px] h-fit relative lg:min-w-[480px] shadow-dropshadow2">
              <div className="flex lg:p-[24px] p-[16px] items-center gap-[8px] self-stretch lg:border-b-[1px] border-solid border-[#F4F4F4]">
                <span className="text-title-large !font-bold">
                  {t('Order summary')}
                </span>
              </div>
              <div className="flex flex-col items-center self-stretch py-16 px-16 lg:px-[24px] gap-[12px]">
                {renderCardItems()}
              </div>
              <Divider type="horizontal" className="m-0 !p-0 self-stretch" />
              <div className="flex flex-col py-16 px-16 lg:px-[24px] items-start gap-[12px] self-stretch">
                <div className="flex items-start justify-between self-stretch">
                  <span className="text-label-large font-semibold text-black/60">
                    {t('Subtotal')}
                  </span>
                  <span className="text-body-medium font-semibold">
                    {convertForeignCurrency(
                      (data?.amount ?? 0) + (data?.discount ?? 0)
                    )}
                  </span>
                </div>
                <div className="flex items-start justify-between self-stretch flex-wrap gap-[8px]">
                  <span className="text-label-large font-semibold text-black/60">
                    {t('Coupon')}
                  </span>
                  <div className="flex items-center justify-end gap-[8px]">
                    {(() => {
                      try {
                        if (Array.isArray(data.applied_coupons)) {
                          return data.applied_coupons;
                        } else if (typeof data.applied_coupons === 'string') {
                          return JSON.parse(data.applied_coupons);
                        } else if (typeof data.applied_coupons === 'string') {
                          return JSON.parse(data.applied_coupons);
                        }
                      } catch (error) {
                        console.log(error);
                        return [];
                      }
                    })()
                      ?.filter(item => item.result)
                      ?.map(item => {
                        return (
                          <Tag
                            key={item.code}
                            label={
                              <div className="flex items-center justify-center gap-[4px]">
                                <span className="flex w-[16px] h-[16px]">
                                  <Icon.ICPercentDiscount />
                                </span>
                                <span className="text-label-medium">
                                  {(() => {
                                    if (item.discount_type === 'percent') {
                                      return t('{{x}}% Off', {
                                        x:
                                          item.discount_type === 'percent'
                                            ? `${item.discount_value || 0}`
                                            : `${convertForeignCurrency(item.discount_value)}`,
                                      });
                                    } else {
                                      return item.code;
                                    }
                                  })()}
                                </span>
                              </div>
                            }
                            className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                          />
                        );
                      })}

                    <span className="text-body-medium font-semibold">
                      -{convertForeignCurrency(Number(data?.discount ?? 0))}
                    </span>
                  </div>
                </div>
              </div>
              <Divider type="horizontal" className="m-0 !p-0 self-stretch" />
              <div className="flex lg:p-[24px] p-[16px] justify-between items-center self-stretch">
                <span className="text-label-large font-semibold text-black/60">
                  {t('Shipping fee')}
                </span>
                <span className="text-body-medium font-semibold">
                  {data?.shipping_fee
                    ? convertForeignCurrency(Number(data?.shipping_fee))
                    : t('Free')}
                </span>
              </div>
              <Divider type="horizontal" className="m-0 !p-0 self-stretch" />
              <div className="flex lg:p-[24px] p-[16px] justify-between items-center self-stretch">
                <span className="text-label-large font-semibold text-black/60">
                  {t('Total price')}
                </span>
                <span className="text-title-medium">
                  {convertForeignCurrency(Number(data.amount))}
                </span>
              </div>
              <Divider type="horizontal" className="m-0 !p-0 self-stretch" />
              {country_code === 'vn' && (
                <div className="flex py-16 px-16 lg:px-[24px] flex-col items-start gap-[12px] self-stretch">
                  <div className="flex p-[12px] items-start gap-[12px] self-stretch rounded-[8px] bg-[#F2F8FD]">
                    <div className="flex w-[20px] h-[20px] justify-center items-center gap-[10px] text-primary-primary">
                      <Icon.ICDelivery />
                    </div>
                    <div className="flex flex-col items-start gap-[6px] self-stretch">
                      <span className="self-stretch text-body-small font-semibold">
                        {t('Estimated delivery date')}
                      </span>
                      <span className="text-body-medium font-semibold">
                        {formatDateTime(
                          data?.estimated_delivery_date,
                          'dateFormat.date'
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {(data?.discount ?? 0) ? (
                <>
                  <Divider
                    type="horizontal"
                    className="m-0 !p-0 self-stretch"
                  />
                  <div className="flex lg:p-[24px] p-[16px] items-start gap-[8px] self-stretch">
                    <span className="w-[24px] h-[24px] flex text-[#49AC3E]">
                      <Icon.ICSuccess />
                    </span>
                    <div className="flex items-center gap-[4px]">
                      <span className="text-body-medium">
                        {t('You have saved')}
                      </span>
                      <span className="text-body-medium font-semibold">
                        {convertForeignCurrency(Number(data?.discount ?? 0))}
                      </span>
                    </div>
                  </div>
                </>
              ) : null}
            </section>
          </div>
        </Form>
      </>
    );
  }
};

export default PaymentPage;

const SuccessfulPayment = ({ order }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="flex lg:py-[32px] lg:px-80 flex-col items-center lg:gap-[24px] grow self-stretch">
      <div className="lg:flex lg:!p-0 px-16 py-12 grow grid grid-cols-5  lg:py-[24px] lg:px-80 flex-col lg:justify-start lg:items-start justify-center items-center gap-16 self-stretch lg:bg-transparent bg-fills-white">
        <ButtonIconOutlineLarge
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden col-span-1"
        />

        <span className="!font-bold text-title-large lg:text-headline-small flex flex-col items-center justify-center gap-[24px] grow col-span-3">
          {t('Payment')}
        </span>
      </div>
      <div className="flex self-stretch grow lg:pt-[32px] p-[16px] flex-col justify-center items-center lg:gap-[40px] gap-[24px]">
        <div className="flex flex-col items-center gap-[24px]">
          <div className="flex p-[16px] items-center rounded-[100px] bg-primary-primary text-white">
            <span className="flex w-[40px] h-[40px]">
              <Icon.ICCheck />
            </span>
          </div>
          <div className="flex lg:w-[900px] text-center flex-col items-center gap-16">
            <span className="text-primary-primary text-title-large !font-bold">
              {t('Payment successful')}
            </span>
            <span className="text-body-medium">
              {t(
                'Thank you for shopping at Fitta. We will prepare your order and ship it to you as soon as possible.'
              )}
            </span>
          </div>
        </div>
        <div className="flex lg:w-[600px] w-full flex-col items-start rounded-[16px] bg-fills-white shadow-custom">
          <div className="flex items-center py-16 lg:px-[24px] px-16 gap-[8px] border-b-[1px] border-[#E0E0E0] grow self-stretch">
            <span className="text-title-large">{t('Order information')}</span>
          </div>
          <div className="flex lg:p-[24px] p-[16px] flex-col items-start gap-[12px] border-b-[1px] border-[#E0E0E0] grow self-stretch">
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Order ID')}</span>
              <span className="label-large text-primary-primary">
                {order?.detail?.code}
              </span>
            </div>
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Recipient')}</span>
              <span className="label-large">{order?.detail?.name_owner}</span>
            </div>
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Email')}</span>
              <span className="label-large">{order?.detail?.email}</span>
            </div>
          </div>
          <div className="flex lg:p-[24px] p-[16px] flex-col items-start gap-[12px] grow self-stretch">
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Amount paid')}</span>
              <span className="label-large text-primary-primary">
                {convertForeignCurrency(order?.detail?.amount_paid ?? 0)}
              </span>
            </div>
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Shipping fee')}</span>
              <span className="label-large text-primary-primary">
                {order?.detail?.shipping_fee
                  ? convertForeignCurrency(order?.detail?.shipping_fee ?? 0)
                  : t('Free')}
              </span>
            </div>
            <div className="flex items-center justify-between grow self-stretch">
              <span className="text-body-medium">{t('Total')}</span>
              <span className="label-large">
                {convertForeignCurrency(
                  (order?.detail?.amount ?? 0) -
                    (order?.detail?.discount ?? 0) +
                    (order?.detail?.shipping_fee ?? 0)
                )}
              </span>
            </div>
          </div>
        </div>

        <ButtonSecondaryLarge
          title={t('Về trang chủ')}
          onClick={() => navigate('/')}
          posIcon={<Icon.ICHome />}
        />
      </div>
    </section>
  );
};

const FailurePayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className="flex lg:py-[32px] lg:px-80 flex-col items-center lg:gap-[24px] grow self-stretch">
      <div className="lg:flex lg:!p-0 px-16 py-12 grow grid grid-cols-5  lg:py-[24px] lg:px-80 flex-col lg:justify-start lg:items-start justify-center items-center gap-16 self-stretch lg:bg-transparent bg-fills-white">
        <ButtonIconOutlineLarge
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden col-span-1"
        />

        <span className="!font-bold text-title-large lg:text-headline-small flex flex-col items-center justify-center gap-[24px] grow col-span-3">
          {t('Payment')}
        </span>
      </div>
      <div className="flex self-stretch grow p-[16px] lg:pt-[32px] flex-col items-center lg:gap-[40px] gap-16">
        <div className="flex flex-col items-center gap-[24px]">
          <div className="flex p-[16px] items-center rounded-[100px] bg-Accents-Red text-white">
            <span className="flex w-[40px] h-[40px]">
              <Icon.ICClose />
            </span>
          </div>
          <div className="flex lg:w-[900px] text-center flex-col items-center gap-16">
            <span className="text-Accents-Red text-title-large !font-bold">
              {t('Payment failed')}
            </span>
            <span className="text-body-medium">
              {t(
                'We are unable to process your payment at this time. Please double-check your information and try again.'
              )}
            </span>
          </div>
        </div>
        <div className="flex lg:h-[60px]"></div>

        <div className="flex lg:items-center lg:justify-center items-start gap-[12px] self-stretch ">
          <ButtonPrimaryLarge
            title={t('Try again')}
            onClick={() => {
              window.location.reload();
            }}
            className="lg:w-[200px] w-full"
          />
          <ButtonSecondaryLarge
            title={t('Back to Homepage')}
            onClick={() => {
              navigate('/');
            }}
            className="lg:w-[200px] w-full"
          />
        </div>
      </div>
    </section>
  );
};

const WarningPayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className="flex lg:py-[32px] lg:px-80 flex-col items-center lg:gap-[24px] grow self-stretch">
      <div className="lg:flex lg:!p-0 px-16 py-12 grow grid grid-cols-5  lg:py-[24px] lg:px-80 flex-col lg:justify-start lg:items-start justify-center items-center gap-16 self-stretch lg:bg-transparent bg-fills-white">
        <ButtonIconOutlineLarge
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden col-span-1"
        />

        <span className="!font-bold text-title-large lg:text-headline-small flex flex-col items-center justify-center gap-[24px] grow col-span-3">
          {t('Payment')}
        </span>
      </div>
      <div className="flex self-stretch grow lg:pt-[32px] p-[16px] flex-col lg:justify-center items-center lg:gap-[40px] gap-16">
        <div className="flex flex-col items-center gap-[24px]">
          <div className="flex p-[16px] items-center rounded-[100px] bg-[#F97D16] text-white">
            <span className="flex w-[40px] h-[40px]">
              <Icon.ICWarning />
            </span>
          </div>
          <div className="flex lg:w-[900px] text-center flex-col items-center gap-16">
            <span className="text-[#F97D16] text-title-large !font-bold">
              {t('Payment order not found')}
            </span>
            <span className="text-body-medium">
              {t('Please return to the order list to continue payment.')}
            </span>
          </div>
        </div>

        <ButtonSecondaryLarge
          title={t('Back to Cart')}
          onClick={() => navigate('/account/orders')}
        />
      </div>
    </section>
  );
};
